import { useEffect } from "react";
import { Landmark, Plus } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import {
  fetchDepositAccounts,
  setDepositAccountModalStatus,
} from "../../../store/DepositAccountSlice";
import { DataList, DataListColumn, StatusBadge } from "../../../components/ui";
import { DepositAccount, DepositAccountType } from "../../../models/DepositAccount";
import ModalAddDepositAccount from "../../../components/modal/modal-add-deposit-account/modal-add-deposit-account";

const DepositAccounts = () => {
  const dispatch = useAppDispatch();
  const accounts = useAppSelector((s) => s.depositAccount.accounts);
  const modalStatus = useAppSelector((s) => s.depositAccount.modalStatus);

  useEffect(() => {
    dispatch(fetchDepositAccounts());
  }, [dispatch]);

  const openModal = () => dispatch(setDepositAccountModalStatus(true));
  const closeModal = () => dispatch(setDepositAccountModalStatus(false));

  const columns: DataListColumn<DepositAccount>[] = [
    {
      key: "nickname",
      header: "Apelido",
      width: "1.2fr",
      render: (a) => (
        <span className="cell-stack">
          <strong>{a.nickname}</strong>
          <small className="num">#{a.id}</small>
        </span>
      ),
    },
    {
      key: "type",
      header: "Tipo",
      render: (a) => (
        <StatusBadge
          tone={a.type === DepositAccountType.CRYPTO ? "info" : "success"}
          label={a.type}
        />
      ),
    },
    {
      key: "detail",
      header: "Detalhes",
      width: "2fr",
      render: (a) =>
        a.type === DepositAccountType.FIAT ? (
          <span className="cell-stack">
            <strong>{a.bank?.name}</strong>
            <small>
              Ag. {a.agency} · Conta {a.account} · {a.transfer_type}
            </small>
          </span>
        ) : (
          <span className="cell-stack">
            <strong>{a.network?.name}</strong>
            <small className="num">{a.hash}</small>
          </span>
        ),
    },
  ];

  return (
    <>
      <div className="client-wrapper deposit-accounts-wrapper">
        <h1 className="page-title">
          <div className="text">
            Contas de Deposito
            <small>
              cadastre as contas (FIAT e CRYPTO) que a empresa usa para receber
              depositos.
            </small>
          </div>
          <div className="buttons">
            <div className="btn purple" onClick={openModal}>
              <Plus size={16} /> Adicionar Conta
            </div>
          </div>
        </h1>

        <hr />

        <DataList
          columns={columns}
          rows={accounts || []}
          loading={accounts === null}
          rowKey={(a: DepositAccount) => a.id}
          empty="Nenhuma conta cadastrada ainda. Clique em 'Adicionar Conta' para comecar."
        />
      </div>

      {modalStatus && <ModalAddDepositAccount onClose={closeModal} />}
    </>
  );
};

export default DepositAccounts;
